// Single i18next instance for the whole frontend -- both guest and manager pages read from this
// (see LanguageSwitcher.jsx for guests, useSyncLocale.js for how a page syncs it to the
// server-resolved `locale` Inertia prop). Bundles are imported directly rather than loaded async:
// at two small languages the whole set is a trivial addition to the bundle size, and it avoids a
// second async-loading failure mode on top of everything else this feature already has to get
// right. Adding a language means adding its bundle files here plus an entry in
// PerfectPairings::SupportedLocales::LOCALES -- nothing else changes.
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import commonEn from './locales/en/common.json'
import commonNl from './locales/nl/common.json'

i18n.use(initReactI18next).init({
  resources: {
    en: { common: commonEn },
    nl: { common: commonNl },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
})

export default i18n
